const config = {
  'module.config': '一般設定',
  'config.title.edit': '一般設定',
  'config.field.apiSecret': '廠商 Secret Key',
  'config.field.apiToken': '介接金鑰 Token',
}

export default config
